module.exports = "/images/city2.jpg?91c3793b037083667127479b3c5779cf";